var TabGroupModule = /** @class */ (function () {
    function TabGroupModule() {
    }
    return TabGroupModule;
}());
export { TabGroupModule };
